import { h, Fragment } from "preact";
import { useEffect, useMemo, useState } from "preact/hooks";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Link,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import CardTemplate from "./CardTemplate";
import { fetchDealExport, updateDealClassifiedTitle } from "./api";

const CHANNELS = [
    { key: "bkeys", name: "BKEYS (site public)" },
    { key: "seloger", name: "SeLoger" },
    { key: "logic_immo", name: "Logic-Immo" },
    { key: "bienici", name: "Bien'ici" },
];

const STATUS = {
    online: { label: "En ligne", color: "#00a65a" },
    offline: { label: "Non publié", color: "#9e9e9e" },
    pending: { label: "Synchronisation en cours", color: "#f2a000" },
    error: { label: "Erreur de synchronisation", color: "#d32f2f" },
    unknown: { label: "Inconnu", color: "#9e9e9e" },
};

function ChannelLogo({ channelKey }) {
    if (channelKey === "bkeys") {
        return (
            <Box sx={{ width: 68, flexShrink: 0 }}>
                <Typography
                    component="div"
                    sx={{ color: "#e30613", fontSize: 21, fontWeight: 800, lineHeight: 0.9 }}
                >
                    Bkeys
                </Typography>
            </Box>
        );
    }

    if (channelKey === "seloger") {
        return (
            <Box sx={{ width: 68, flexShrink: 0, display: "flex", alignItems: "center" }}>
                <Box
                    component="svg"
                    viewBox="0 0 91.7 32"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-label="SeLoger"
                    sx={{ width: 62, height: "auto", display: "block" }}
                >
                    <title>SeLoger Homepage</title>
                    <path
                        d="m58.121 28c4.102 0 6.737-1.62 7.813-6.29l2.812-12.109h-3.925l-.293 1.271c-.624-.899-1.718-1.62-3.436-1.62-4.432 0-7.286 3.459-7.421 7.342-.117 3.631 2.402 5.586 5.195 5.586 1.681 0 2.715-.661 3.436-1.601l-.354 1.504c-.428 1.857-1.583 2.928-3.435 2.928-1.29 0-1.877-.526-1.974-2.09l-3.827.74c-.019 2.868 2.048 4.334 5.409 4.334m-58.121-11.555c.507 3.827 3.319 6.308 7.966 6.308 4.646 0 6.779-2.677 6.779-5.801s-1.779-4.688-5.764-5.526c-3.222-.684-3.985-1.345-3.985-2.323 0-1.034.838-1.699 2.36-1.699 2.048 0 3.008 1.191 3.264 2.286h4.18c-.875-4.125-3.785-5.685-7.36-5.685-3.925 0-6.504 2.09-6.504 5.172 0 3.083 2.048 4.763 5.684 5.466 2.696.508 3.986 1.173 3.986 2.598 0 1.057-.978 1.858-2.635 1.858-2.538 0-3.516-1.425-3.73-2.659h-4.241zm15.21-.452c0 4.023 3.087 6.756 6.565 6.756 3.221 0 5.721-1.388 6.601-4.707h-3.887c-.293.898-1.076 1.56-2.519 1.56-1.583 0-2.891-.936-3.105-2.561h9.511c.079-.428.159-.978.159-1.406 0-3.552-2.519-6.388-6.486-6.388-3.924 0-6.834 2.733-6.834 6.737m3.71-1.345c.354-1.504 1.523-2.342 3.124-2.342 1.602 0 2.542.74 2.812 2.342zm8.986 7.751h10.075l.88-3.789h-5.862l3.264-14.256h-4.218zm11.034-5.465c-.117 3.3 2.658 5.819 6.131 5.819 4.763 0 8.143-3.124 8.301-7.44.14-3.887-2.518-6.052-6.21-6.052-4.824 0-8.064 3.338-8.222 7.673m4.064-.587c.061-1.737 1.388-3.436 3.515-3.436 1.737 0 2.849 1.034 2.794 2.677-.061 2.072-1.639 3.515-3.613 3.515-1.364 0-2.752-.978-2.696-2.756m14.61-.14c.06-1.76 1.289-3.496 3.436-3.496 1.308 0 2.402.861 2.341 2.384-.079 2.029-1.503 3.631-3.319 3.631-1.308 0-2.519-.801-2.463-2.519m14.023-1.559c.545-1.523 2.011-2.342 3.575-2.342 1.858 0 2.873.684 2.812 2.342zm-4.004 2.109c-.116 3.575 2.17 5.996 5.764 5.996 3.142 0 5.489-1.131 6.834-3.887l-3.478-.685c-.33.685-1.406 1.425-2.83 1.425-1.639 0-2.519-.899-2.561-2.561h9.586c.312-.861.526-1.895.526-2.891 0-2.812-2.262-4.902-5.996-4.902-4.609 0-7.715 3.557-7.85 7.5m12.599 5.643h3.924l1.327-5.801c.545-2.384 1.858-3.692 3.711-3.692.409 0 .661.06.996.158l1.485-3.631c-.33-.117-.703-.177-1.154-.177-1.583 0-3.008.74-3.925 2.286l.47-1.933h-3.906z"
                        fill="#E30513"
                    />
                </Box>
            </Box>
        );
    }

    if (channelKey === "logic_immo") {
        return (
            <Box sx={{ width: 68, flexShrink: 0, display: "flex", alignItems: "center" }}>
                <Box
                    component="svg"
                    viewBox="0 0 63 32"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-label="Logic-Immo"
                    sx={{ width: 58, height: "auto", display: "block" }}
                >
                    <title>LogicImmo Homepage</title>
                    <g fillRule="evenodd" clipRule="evenodd">
                        <path fill="#2CABE5" d="M0 23.815v2.573h7.338v-2.573z" />
                        <path
                            fill="#000"
                            d="M.03.284v13.928h8.125v-3.07h-4.95V.285zM16.49 3.11c2.259 0 4.043 1.65 4.043 4.133 0 2.492-1.784 4.143-4.042 4.143s-4.042-1.651-4.042-4.143c0-2.482 1.784-4.133 4.042-4.133zm0-3.11C12.5 0 9.285 3.14 9.285 7.243c0 4.092 3.215 7.253 7.207 7.253 3.982 0 7.207-3.15 7.207-7.253S20.473 0 16.491 0zm16.36 0c-4.072 0-7.267 3.231-7.267 7.273 0 4.001 3.135 7.223 7.49 7.223 3.89 0 6.834-2.584 6.834-6.848V6.453h-6.945v2.775h3.699c-.494 1.337-1.704 2.158-3.548 2.158-2.692 0-4.355-1.742-4.355-4.103 0-2.451 1.744-4.183 4.083-4.183 1.562 0 2.802.719 3.387 1.64l2.69-1.55C37.75 1.318 35.503 0 32.852 0zm9.97.284v13.928h3.175V.284zM56.115 0c-4.183 0-7.217 3.14-7.217 7.243 0 4.092 3.034 7.242 7.217 7.242 2.52 0 4.738-1.255 5.927-3.22l-2.731-1.591c-.585 1.074-1.795 1.712-3.196 1.712-2.46 0-4.042-1.651-4.042-4.143 0-2.482 1.583-4.143 4.042-4.143 1.401 0 2.591.638 3.196 1.712l2.731-1.59C60.842 1.245 58.625 0 56.115 0zM9.546 17.788v13.928h3.175V17.788zm6.078 0v13.928h3.165v-8.093l3.589 5.915h.363l3.588-5.915v8.093h3.155V17.788h-3.165l-3.77 6.19-3.76-6.19zm16.773 0v13.928h3.175v-8.093l3.579 5.915h.353l3.588-5.915v8.093h3.175V17.788h-3.175l-3.76 6.19-3.76-6.19zm23.396 2.836c2.258 0 4.032 1.641 4.032 4.133 0 2.474-1.764 4.133-4.012 4.133h-.02c-2.268 0-4.042-1.651-4.042-4.133 0-2.492 1.774-4.133 4.042-4.133zm0-3.12c-3.992 0-7.217 3.15-7.217 7.253S51.81 32 55.792 32C59.775 32 63 28.86 63 24.757s-3.225-7.253-7.207-7.253z"
                        />
                    </g>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ width: 68, flexShrink: 0, display: "flex", alignItems: "center" }}>
            <Box
                component="svg"
                viewBox="0 0 907 190"
                xmlns="http://www.w3.org/2000/svg"
                aria-label="Bien'ici"
                sx={{ width: 64, height: "auto", display: "block" }}
            >
                <title>Bien&apos;ici</title>
                <defs>
                    <filter id="bienici-shadow" x="-100%" y="-100%" width="300%" height="300%">
                        <feOffset result="offOut" in="SourceAlpha" dx="0" dy="10" />
                        <feGaussianBlur result="blurOut" in="offOut" stdDeviation="15" />
                        <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
                    </filter>
                </defs>
                <g fill="none" fillRule="evenodd">
                    <path
                        d="M0 83.459c0 19.518 13.498 42.827 40.12 69.28 19.049 18.928 37.818 32.48 38.607 33.05l5.132 3.688 5.13-3.689c.79-.567 19.56-14.12 38.608-33.049 26.622-26.453 40.12-49.762 40.12-69.28C167.718 37.439 130.098 0 83.859 0 37.619 0 0 37.44 0 83.459zm83.859-66.016c18.87 0 35.913 7.896 48.002 20.527a52.434 52.434 0 0 0-13.27-1.684c-13.805 0-26.351 5.28-34.734 14.096-8.383-8.816-20.929-14.096-34.735-14.096-4.682 0-9.11.599-13.261 1.678 12.09-12.627 29.13-20.52 47.998-20.52zM17.527 83.46c0-3.351.257-6.643.743-9.862.43-1.22.92-2.441 1.519-3.66 5.36-10.916 16.326-17.432 29.334-17.432 22.026 0 30.192 16.9 34.735 24.185 4.836-7.758 13.772-24.185 34.734-24.185 13.008 0 23.974 6.517 29.335 17.433.6 1.22 1.091 2.444 1.522 3.668.485 3.215.742 6.505.742 9.853 0 27.827-43.93 67.212-66.332 84.37-22.403-17.157-66.332-56.542-66.332-84.37z"
                        fill="#FFB90C"
                    />
                    <path
                        d="M222.9 162.743V23h22.214v62.289h.542c7.284-9.028 17.338-13.541 30.16-13.541 12.583 0 22.877 4.438 30.884 13.315 8.007 8.877 12.01 19.965 12.01 33.266 0 13.42-3.973 24.554-11.92 33.4-7.946 8.848-18.572 13.271-31.876 13.271-14.027 0-24.201-5.176-30.522-15.527h-.361v13.27H222.9zm21.492-44.37c0 7.253 2.378 13.497 7.134 18.733 4.756 5.235 11.077 7.853 18.963 7.853 7.886 0 14.192-2.618 18.918-7.853 4.726-5.236 7.089-11.48 7.089-18.732 0-7.252-2.363-13.496-7.089-18.732-4.726-5.236-11.032-7.854-18.918-7.854-7.886 0-14.207 2.618-18.963 7.854-4.756 5.236-7.134 11.48-7.134 18.732zm109.418 44.37V74.004h22.214v88.74H353.81zm57.314-44.37c0-13.69 4.62-24.885 13.861-33.58 9.241-8.697 20.724-13.045 34.45-13.045 12.582 0 22.65 4.257 30.206 12.773 7.555 8.516 11.333 20.357 11.333 35.523v6.048h-67.636c.723 6.38 3.311 11.495 7.766 15.347 4.455 3.851 9.813 5.777 16.074 5.777 9.391 0 17.338-4.002 23.84-12.006l15.892 12.006C487.278 159.072 474.787 165 459.435 165c-13.665 0-25.134-4.348-34.405-13.045-9.27-8.696-13.906-19.89-13.906-33.581zm22.214-8.891h45.512c-.12-6.56-2.182-11.706-6.186-15.437-4.003-3.731-9.466-5.597-16.39-5.597-6.38 0-11.588 1.866-15.621 5.597-4.034 3.731-6.472 8.877-7.315 15.437zm102.375 53.261V74.004h21.13v14.264h.361c5.057-10.954 14.118-16.46 27.181-16.52 11.077 0 19.235 3.31 24.472 9.93 5.238 6.62 7.856 14.955 7.856 25.005v56.06H594.59v-44.956c0-3.19-.165-5.988-.496-8.395-.331-2.408-.948-5.116-1.851-8.125-.903-3.01-2.529-5.341-4.877-6.996-2.348-1.655-5.388-2.483-9.12-2.483-6.923 0-12.04 2.122-15.351 6.365-3.312 4.242-4.967 9.614-4.967 16.113v48.477h-22.214zM364.917 57.9c7.735 0 14.005-6.269 14.005-14 0-7.733-6.27-14.001-14.005-14.001-7.735 0-14.005 6.268-14.005 14s6.27 14 14.005 14zm290.575 11.237c.648-1.512 1.087-2.997 1.318-4.458.23-1.46.164-2.802-.199-4.027s-1.158-2.273-2.386-3.142c-2.455-1.739-4.485-3.81-6.089-6.214-1.604-2.404-2.213-5.173-1.828-8.308a14.308 14.308 0 0 1 1.732-5.33c.92-1.633 2.088-3.004 3.508-4.113 1.419-1.109 3.032-1.911 4.838-2.408a14.308 14.308 0 0 1 5.591-.392c3.843.472 6.911 2.235 9.206 5.288 2.294 3.054 3.306 6.514 3.036 10.382-.193 4.082-1.186 7.784-2.98 11.105-1.794 3.322-3.787 6.182-5.981 8.582-2.194 2.4-4.303 4.322-6.328 5.767-2.026 1.445-4.085-1.22-3.438-2.732z"
                        fill="#495962"
                    />
                    <path
                        d="M716.238 162.743V74.004h22.214v88.74h-22.214zm57.314-44.37c0-13.69 4.62-24.885 13.861-33.58 9.241-8.697 20.724-13.045 34.45-13.045 13.305 0 24.02 4.513 32.148 13.54l-15.352 15.347c-5.658-5.898-11.257-8.847-16.796-8.847-7.886 0-14.207 2.618-18.963 7.854-4.756 5.236-7.134 11.48-7.134 18.732 0 7.252 2.378 13.496 7.134 18.732 4.756 5.235 11.077 7.853 18.963 7.853 7.285 0 13.004-2.768 17.158-8.305l14.81 15.888c-4.095 4.093-9.242 7.192-15.442 9.298-6.201 2.107-11.71 3.16-16.526 3.16-13.665 0-25.134-4.348-34.405-13.045-9.27-8.696-13.906-19.89-13.906-33.581zm104.903-74.475c0-3.58 1.355-6.695 4.064-9.343 2.709-2.648 6.02-3.972 9.933-3.972 4.093 0 7.525 1.264 10.294 3.791 2.77 2.528 4.154 5.703 4.154 9.524 0 3.822-1.385 6.996-4.154 9.524-2.77 2.528-6.2 3.792-10.294 3.792-3.974 0-7.3-1.324-9.979-3.972-2.679-2.648-4.018-5.763-4.018-9.344zm3.07 118.845V74.004h22.214v88.74h-22.214zM726.345 57.9c7.735 0 14.005-6.269 14.005-14 0-7.733-6.27-14.001-14.005-14.001-7.735 0-14.005 6.268-14.005 14s6.27 14 14.005 14z"
                        fill="#FFB90C"
                    />
                </g>
            </Box>
        </Box>
    );
}

function StatusLine({ channel }) {
    const fallback = STATUS[channel.status] || STATUS.unknown;
    const label = channel.status_label || fallback.label;

    return (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.45 }}>
            <Box
                component="span"
                sx={{
                    display: "inline-block",
                    width: 11,
                    height: 11,
                    borderRadius: "50%",
                    bgcolor: fallback.color,
                    flexShrink: 0,
                }}
            />
            <Typography variant="body2" sx={{ color: "#333", lineHeight: 1.2 }}>
                {label}
            </Typography>
        </Stack>
    );
}

function ChannelRow({ channel, isLast, missingClassifiedTitle }) {
    const blockedByTitle =
        missingClassifiedTitle && (channel.key === "seloger" || channel.key === "logic_immo");

    return (
        <Box
            sx={{
                minHeight: 60,
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                px: 1.2,
                py: 0.7,
                borderBottom: isLast ? "none" : "1px solid #eaeaea",
            }}
        >
            <ChannelLogo channelKey={channel.key} />

            <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                    <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#222" }}>
                        {channel.name}
                    </Typography>
                    {blockedByTitle && (
                        <Typography
                            component="span"
                            sx={{
                                color: "#ed6c02",
                                fontSize: 12,
                                fontWeight: 700,
                                lineHeight: 1.2,
                            }}
                        >
                            NON PUBLIABLE : TITRE MANQUANT
                        </Typography>
                    )}
                </Stack>
                {!blockedByTitle && <StatusLine channel={channel} />}
            </Box>

            {channel.remote_url ? (
                <Link
                    href={channel.remote_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                    sx={{
                        ml: 1,
                        whiteSpace: "nowrap",
                        color: "#ff3b3b",
                        fontSize: 13,
                        fontWeight: 500,
                        "&:hover": { textDecoration: "underline" },
                    }}
                >
                    Voir l'annonce&nbsp;&nbsp;
                    <Box component="span" aria-hidden="true" sx={{ fontSize: 20, lineHeight: 0 }}>
                        ↗
                    </Box>
                </Link>
            ) : (
                <Typography
                    variant="body2"
                    sx={{ ml: 1, whiteSpace: "nowrap", color: "#aaa", fontSize: 13 }}
                >
                    Pas de lien
                </Typography>
            )}
        </Box>
    );
}

function formatSyncDate(value) {
    if (!value) return null;

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;

    const datePart = new Intl.DateTimeFormat("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric",
    }).format(date);

    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");

    return `${datePart} à ${hour} h ${minute}`;
}

function mergeChannels(payload) {
    const received = new Map((payload?.channels || []).map((channel) => [channel.key, channel]));

    return CHANNELS.map((channel) => ({
        ...channel,
        status: "unknown",
        remote_url: null,
        ...received.get(channel.key),
    }));
}

export default function PublicationCard({ uid }) {
    const [payload, setPayload] = useState(null);
    const [loading, setLoading] = useState(Boolean(uid));
    const [error, setError] = useState(null);
    const [reloadToken, setReloadToken] = useState(0);
    const [titleDialogOpen, setTitleDialogOpen] = useState(false);
    const [titleDraft, setTitleDraft] = useState("");
    const [savingTitle, setSavingTitle] = useState(false);
    const [titleError, setTitleError] = useState(null);

    useEffect(() => {
        if (!uid) {
            setPayload(null);
            setError(null);
            setLoading(false);
            return undefined;
        }

        const controller = new AbortController();
        setLoading(true);
        setError(null);

        fetchDealExport(uid, controller.signal)
            .then((data) => setPayload(data))
            .catch((requestError) => {
                if (requestError.name !== "AbortError") {
                    setError(requestError);
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, [uid, reloadToken]);

    const channels = useMemo(() => mergeChannels(payload), [payload]);
    const lastSync = formatSyncDate(payload?.last_sync_at);
    const missingClassifiedTitle = !String(payload?.classified_title || "").trim();

    const openTitleDialog = () => {
        setTitleDraft(payload?.classified_title || "");
        setTitleError(null);
        setTitleDialogOpen(true);
    };

    const saveClassifiedTitle = async () => {
        if (!uid || savingTitle) return;

        setSavingTitle(true);
        setTitleError(null);

        try {
            const normalizedTitle = String(titleDraft || "").trim();
            await updateDealClassifiedTitle(uid, normalizedTitle);

            // Relire explicitement le backend pour confirmer que la valeur a bien été persistée.
            const persistedPayload = await fetchDealExport(uid);
            const persistedTitle = String(persistedPayload?.classified_title || "").trim();

            if (persistedTitle !== normalizedTitle) {
                throw new Error("Le titre n’a pas été sauvegardé en base.");
            }

            setPayload(persistedPayload);
            setTitleDraft(persistedPayload?.classified_title || "");
            setTitleDialogOpen(false);
        } catch (requestError) {
            setTitleError(requestError?.message || "Impossible d’enregistrer le titre.");
        } finally {
            setSavingTitle(false);
        }
    };

    const buttons = (
        <Button
            size="small"
            variant="contained"
            disabled={!uid || loading}
            onClick={openTitleDialog}
            sx={{
                mt: 1,
                mr: 1,
                whiteSpace: "nowrap",
                textTransform: "none",
                bgcolor: "#f34b40",
                color: "#fff",
                "&:hover": { bgcolor: "#df4037" },
                "&.Mui-disabled": { bgcolor: "#f6aaa5", color: "#fff" },
            }}
        >
            {missingClassifiedTitle ? "RENSEIGNER LE TITRE" : "MODIFIER LE TITRE"}
        </Button>
    );

    const content = (
        <Box sx={{ mx: -0.6, mb: -0.6 }}>
            {loading ? (
                <Box
                    sx={{
                        minHeight: 160,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <CircularProgress size={26} />
                </Box>
            ) : error ? (
                <Stack alignItems="center" spacing={1.2} sx={{ py: 3 }}>
                    <Typography variant="body2" color="error">
                        Impossible de récupérer les statuts de publication.
                    </Typography>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={() => setReloadToken((value) => value + 1)}
                    >
                        Réessayer
                    </Button>
                </Stack>
            ) : (
                <>
                    <Box>
                        {channels.map((channel, index) => (
                            <ChannelRow
                                key={channel.key}
                                channel={channel}
                                isLast={index === channels.length - 1}
                                missingClassifiedTitle={missingClassifiedTitle}
                            />
                        ))}
                    </Box>

                    <Box
                        sx={{
                            borderTop: "1px solid #eaeaea",
                            mt: 0.5,
                            px: 1.2,
                            py: 1.25,
                            textAlign: "center",
                        }}
                    >
                        <Typography sx={{ fontSize: 13, color: "#444" }}>
                            Dernière synchronisation :{" "}
                            <Box component="span" sx={{ fontWeight: 700 }}>
                                {lastSync || "aucune synchronisation"}
                            </Box>
                        </Typography>
                    </Box>
                </>
            )}
        </Box>
    );

    return (
        <Fragment>
            <CardTemplate title="Diffusion des annonces" buttons={buttons} content={content} />

            <Dialog
                open={titleDialogOpen}
                onClose={() => !savingTitle && setTitleDialogOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Titre de l’annonce</DialogTitle>
                <DialogContent>
                    <Typography sx={{ mb: 1.5, color: "#666", fontSize: 13 }}>
                        Ce titre est obligatoire pour publier l’annonce sur SeLoger et Logic-Immo.
                    </Typography>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Titre de l’annonce"
                        value={titleDraft}
                        onChange={(event) => setTitleDraft(event.target.value)}
                        error={Boolean(titleError)}
                        helperText={titleError || (String(titleDraft).trim() ? " " : "Titre obligatoire pour SeLoger et Logic-Immo") }
                        disabled={savingTitle}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setTitleDialogOpen(false)}
                        disabled={savingTitle}
                        sx={{ textTransform: "none" }}
                    >
                        Annuler
                    </Button>
                    <Button
                        variant="contained"
                        onClick={saveClassifiedTitle}
                        disabled={savingTitle}
                        sx={{ textTransform: "none" }}
                    >
                        {savingTitle ? "Enregistrement…" : "Enregistrer"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}
